import React from 'react';
import ReactDOM from 'react-dom';
import './reset.css';
import Layout from './layout/';

/* eslint-disable */
ReactDOM.hydrate(<Layout content={allData} />, document.getElementById('root'));
/* eslint-enable */
